import React from 'react';
import { MenuItemArgs } from './types';
import { IconExportCsv, IconDuplicate, IconManagementReport } from './icons';
import { Poppins } from 'src/common';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import * as S from './util.styles';

export const CSV = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="csv">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:ExportCSV',
        });
      }}
      onMouseEnter={() => setActiveItem('csv')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-csv"
    >
      <div className="icon-container">
        <IconExportCsv isActive={activeItem === 'csv'} />
      </div>
      <Poppins px={16}>{label || 'Export CSV'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const PDF = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="pdf">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:ExportPDF',
        });
      }}
      onMouseEnter={() => setActiveItem('pdf')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-pdf"
    >
      <div className="icon-container">
        <IconExportCsv isActive={activeItem === 'pdf'} />
      </div>
      <Poppins px={16}>{label || 'Export PDF'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const EXPORT_MANAGEMENT_REPORT = ({
  label,
  exe,
  divider,
  resetActiveItem,
  activeItem,
  setActiveItem,
}: MenuItemArgs) => (
  <div key="export-management-report">
    <S.Item
      onClick={exe}
      onMouseEnter={() => setActiveItem('management-report')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-management-report"
    >
      <div className="icon-container">
        <IconManagementReport isActive={activeItem === 'management-report'} />
      </div>
      <Poppins px={16}>{label || 'Export Management Report'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const MD = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="md">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:ExportMD',
        });
      }}
      onMouseEnter={() => setActiveItem('md')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-md"
    >
      <div className="icon-container">
        <IconExportCsv isActive={activeItem === 'md'} />
      </div>
      <Poppins px={16}>{label || 'Export MD'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const DUPLICATE = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="copy">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:Duplicate',
        });
      }}
      onMouseEnter={() => setActiveItem('copy')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-duplicate"
    >
      <div className="icon-container">
        <IconDuplicate isActive={activeItem === 'copy'} />
      </div>
      <Poppins px={16}>{label || 'Duplicate'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const VERSION_HISTORY = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="version-history">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Versions',
        });
      }}
      onMouseEnter={() => setActiveItem('version-history')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-version-history"
    >
      <div className="icon-container">
        <IconDuplicate isActive={activeItem === 'version-history'} />
      </div>
      <Poppins px={16}>{label || 'Version history'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);
